export const USER_INFO_STORAGE_KEY = "OTELLISANSLAMA-USER-INFO";
